// extracted by mini-css-extract-plugin
export default {"container":"sDAMSeNCSAvKjlYd3VS5","label":"yTPCpzmFXHWgG87GgtXG","description":"dRTVJrNkOjxWUu5yJ2yU","termsContainer":"uh5YJ7agtuyeTmJIPoxQ","pulse":"CrJj0KWeUG_J0kB_12Tx"};